/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { memo, useMemo, useState } from 'react';
import {
  Grid,
  MenuItem,
  Select,
  type SelectChangeEvent,
  Typography
} from '@mui/material';
import Rating from '@mui/material/Rating';
import Stack from '@mui/material/Stack';
import { useTranslation } from 'react-i18next';
import { Controller, UseFormReturn } from 'react-hook-form';

const options = Array.from({ length: 10 }, (_, i) => i + 1);

function LinearScale({
  form,
  id,
  value = 0,
  optionsLine,
  isEditable = true,
  isReadOnly = true,
  itemFull,
  onChangeInputs
}: {
  form: UseFormReturn;
  id: string;
  value?: number;
  optionsLine?:  number;
  isReadOnly?: boolean;
  isEditable?: boolean;
  itemFull?: { idSurveyQuestion: string; isRequired: boolean };
  onChangeInputs?: (id: string, key: string, value?: number) => void;
}) {
  const { t } = useTranslation('global');
  const { control, setValue } = form;

  const [maxRange, setMaxRange] = useState<number>(optionsLine || 5);

  const onChange = ({ target }: SelectChangeEvent<number>) => {
    setMaxRange(target?.value as number);
  };

  useMemo(
    () => {
      onChangeInputs(id, 'options', maxRange);
    },
    [id, maxRange]
  );

  return (
    <Grid spacing={2} xs={12}>
      <Stack
        alignItems="center"
        display="flex"
        flexDirection="row"
        width="100%"
      >
        {isReadOnly && 
        <>
          <Typography paddingRight={1}>
            {t('survey.template.from')} <b>1</b> {t('survey.template.to')}
          </Typography>
          {isEditable ? (
            <Select
              name="linearScale"
              onChange={onChange}
              size="small"
              sx={{ width: '5rem', padding: 0 }}
              value={maxRange}
              variant="outlined"
            >
              {options?.map((range) => (
                <MenuItem key={range} value={range}>
                  {range}
                </MenuItem>
              ))}
            </Select>
          ) : (
            <b>{maxRange}</b>
          )}
        </>}
      </Stack>
      <Stack alignItems="center" marginTop={1}>
        {/* Campo oculto para idSurveyQuestion */}
        <Controller
          control={control}
          defaultValue={itemFull?.idSurveyQuestion || ''}
          name={`${id}-idSurveyQuestion`}  // Registra el idSurveyQuestion en el formulario
          render={({ field }) => (
            <input type="hidden" {...field} value={itemFull?.idSurveyQuestion} />
          )}
        />

        <Controller
          control={control}
          defaultValue={value || null}
          name={`${id}-rating`}
          render={({ field, fieldState: { error } }) => (
            <>
              <Rating
                {...field}
                max={maxRange}
                name="size-large"
                onChange={(_, newValue) => {
                  setValue(`${id}-rating`, newValue);
                }}
                readOnly={isReadOnly}
                size="large"
                value={field.value ?? null}
              />
              {error && (
                <Typography color="error" variant="caption">
                  {t('common.commonMessages.requiredField', { field: `${id}-rating` })}
                </Typography>
              )}
            </>
          )}
          rules={{
            required: {
              value: isReadOnly ? false : itemFull?.isRequired,
              message: t('common.commonMessages.requiredField', { field: `${id}-rating` })
            }
          }}
        />
      </Stack>
    </Grid>
  );
}

export default memo(LinearScale);
